var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vs-tabs',{staticClass:"unique_cstm_tab"},[_c('vs-tab',{attrs:{"label":"Email"}},[_c('Email')],1),_c('vs-tab',{attrs:{"label":"Email Template"}},[_c('EmailTemplate')],1),_c('vs-tab',{attrs:{"label":"Email Signature"}},[_c('EmailSignature')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }